import { TextMaskPipe } from './text-mask.pipe';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [TextMaskPipe],
  providers: [TextMaskPipe],
  exports: [TextMaskPipe]
})
export class TextMaskPipeModule { }
